import { ParsedWPBlock } from "@/src/types/Embeds";
import RawContent from "../../RawContent";

//@ts-ignore
export interface ContentRawProps {
  content: ParsedWPBlock[];
}

const ContentRaw = ({ content = [] }: ContentRawProps) => {
  // console.log("Blocks; ", content);
  return (
    <>
      {content.map(function (block, index) {
        return <RawContent block={block} key={index} />;
      })}
    </>
  );
};

export default ContentRaw;
